import React from 'react';
import AdminAccount from '../components/admin/account/AdminAccount';

const AdminAccountPage = () => {
    return (
        <AdminAccount />
    );
};

export default AdminAccountPage;